import { ISignatoryRemarks } from '../../shared/interfaces/application.interface';
import {
  IHrselected,
  IHrFetchPayload,
  IHrDelete,
  IHrApprovalsAddPayload,
  IHrDataList,
  IDashboardStaticDataList,
  IDashboardFetchApplicationPayload,
  IDashboardApplicationDataList,
  IDashboardFetchApprovalPayload,
  IDashboardApprovalDataList,
} from '../../shared/interfaces/hr.interface';
import { IEditHrInformationModal } from '../../shared/interfaces/modal.interface';

export const HR_FETCH_APPLICATIONS = '[HR] FETCH_APPLICATIONS';
export const HR_FETCH_APPLICATIONS_SUCCESS = '[HR] FETCH_APPLICATIONS_SUCCESS';
export const HR_FETCH_APPLICATIONS_ERROR = '[HR] FETCH_APPLICATIONS_ERROR';

export const HR_FETCH_APPLICATION_INFORMATION = '[HR] FETCH_APPLICATION_INFORMATION';
export const HR_FETCH_APPLICATION_INFORMATION_SUCCESS =
  '[HR] FETCH_APPLICATION_INFORMATION_SUCCESS';
export const HR_FETCH_APPLICATION_INFORMATION_ERROR = '[HR] FETCH_APPLICATION_INFORMATION_ERROR';

export const HR_EDIT_APPLICATION_INFORMATION = '[HR] EDIT_APPLICATION_INFORMATION';
export const HR_EDIT_APPLICATION_INFORMATION_SUCCESS = '[HR] EDIT_APPLICATION_INFORMATION_SUCCESS';
export const HR_EDIT_APPLICATION_INFORMATION_ERROR = '[HR] EDIT_APPLICATION_INFORMATION_ERROR';

export const HR_DELETE_APPLICATION = '[HR] DELETE_APPLICATION';
export const HR_DELETE_APPLICATION_SUCCESS = '[HR] DELETE_APPLICATION_SUCCESS';
export const HR_DELETE_APPLICATION_ERROR = '[HR] DELETE_APPLICATION_ERROR';

export const HR_ADD_APPROVER = '[HR] ADD_APPROVER';
export const HR_ADD_APPROVER_SUCCESS = '[HR] ADD_APPROVER_SUCCESS';
export const HR_ADD_APPROVER_ERROR = '[HR] ADD_APPROVER_ERROR';

export const HR_DELETE_APPROVER = '[HR] DELETE_APPROVER';
export const HR_DELETE_APPROVER_SUCCESS = '[HR] DELETE_APPROVER_SUCCESS';
export const HR_DELETE_APPROVER_ERROR = '[HR] DELETE_APPROVER_ERROR';

//  For Dashboard API
export const DASHBOARD_FETCH_STATIC_DATA = '[DASHBOARD] FETCH_STATIC_DATA';
export const DASHBOARD_FETCH_STATIC_DATA_SUCCESS = '[DASHBOARD] FETCH_STATIC_DATA_SUCCESS';
export const DASHBOARD_FETCH_STATIC_DATA_ERROR = '[DASHBOARD] FETCH_STATIC_DATA_ERROR';

export const DASHBOARD_FETCH_APPLICATION_DATA = '[DASHBOARD] FETCH_APPLICATION_DATA';
export const DASHBOARD_FETCH_APPLICATION_DATA_SUCCESS =
  '[DASHBOARD] FETCH_APPLICATION_DATA_SUCCESS';
export const DASHBOARD_FETCH_APPLICATION_DATA_ERROR = '[DASHBOARD] FETCH_APPLICATION_DATA_ERROR';

export const DASHBOARD_FETCH_APPROVAL_DATA = '[DASHBOARD] FETCH_APPROVAL_DATA';
export const DASHBOARD_FETCH_APPROVAL_DATA_SUCCESS = '[DASHBOARD] FETCH_APPROVAL_DATA_SUCCESS';
export const DASHBOARD_FETCH_APPROVAL_DATA_ERROR = '[DASHBOARD] FETCH_APPROVAL_DATA_ERROR';

export const HrFetchApplications = (data: IHrFetchPayload) => ({
  type: HR_FETCH_APPLICATIONS,
  payload: data,
});

export const HrFetchApplicationsSuccess = (data: IHrDataList) => ({
  type: HR_FETCH_APPLICATIONS_SUCCESS,
  payload: data,
});

export const HrFetchApplicationsError = () => ({
  type: HR_FETCH_APPLICATIONS_ERROR,
});

export const HrFetchApplication = (slug: string) => ({
  type: HR_FETCH_APPLICATION_INFORMATION,
  payload: slug,
});

export const HrFetchApplicationSuccess = (data: IHrselected) => ({
  type: HR_FETCH_APPLICATION_INFORMATION_SUCCESS,
  payload: data,
});

export const HrFetchApplicationError = () => ({
  type: HR_FETCH_APPLICATION_INFORMATION_ERROR,
});

export const HrEditApplication = (slug: string, data: IEditHrInformationModal) => ({
  type: HR_EDIT_APPLICATION_INFORMATION,
  slug: slug,
  payload: data,
});

export const HrEditApplicationSuccess = (data: IHrselected) => ({
  type: HR_EDIT_APPLICATION_INFORMATION_SUCCESS,
  payload: data,
});

export const HrEditApplicationError = () => ({
  type: HR_FETCH_APPLICATION_INFORMATION_ERROR,
});

export const HrDeleteApplication = (data: IHrDelete) => ({
  type: HR_DELETE_APPLICATION,
  payload: data,
});

export const HrDeleteApplicationSuccess = (slug: string) => ({
  type: HR_DELETE_APPLICATION_SUCCESS,
  payload: slug,
});

export const HrDeleteApplicationError = () => ({
  type: HR_DELETE_APPLICATION_ERROR,
});

export const HrAddApprover = (data: IHrApprovalsAddPayload) => ({
  type: HR_ADD_APPROVER,
  payload: data,
});

export const HrAddApproverSuccess = (data: ISignatoryRemarks[]) => ({
  type: HR_ADD_APPROVER_SUCCESS,
  payload: data,
});

export const HrAddApproverError = () => ({
  type: HR_ADD_APPROVER_ERROR,
});

export const HrDeleteApprover = (data: string) => ({
  type: HR_DELETE_APPROVER,
  payload: data,
});

export const HrDeleteApproverSuccess = (data: string) => ({
  type: HR_DELETE_APPROVER_SUCCESS,
  payload: data,
});

export const HrDeleteApproverError = () => ({
  type: HR_DELETE_APPROVER_ERROR,
});

export const DashboardStaticData = () => ({
  type: DASHBOARD_FETCH_STATIC_DATA,
});

export const DashboardStaticDataSuccess = (data: IDashboardStaticDataList) => ({
  type: DASHBOARD_FETCH_STATIC_DATA_SUCCESS,
  payload: data,
});

export const DashboardStaticDataError = () => ({
  type: DASHBOARD_FETCH_STATIC_DATA_ERROR,
});

export const DashboardApplicationData = (data: IDashboardFetchApplicationPayload) => ({
  type: DASHBOARD_FETCH_APPLICATION_DATA,
  payload: data,
});

export const DashboardApplicationDataSuccess = (data: IDashboardApplicationDataList) => ({
  type: DASHBOARD_FETCH_APPLICATION_DATA_SUCCESS,
  payload: data,
});

export const DashboardApplicationDataError = () => ({
  type: DASHBOARD_FETCH_APPLICATION_DATA_ERROR,
});

export const DashboardApprovalData = (data: IDashboardFetchApprovalPayload) => ({
  type: DASHBOARD_FETCH_APPROVAL_DATA,
  payload: data,
});

export const DashboardApprovalDataSuccess = (data: IDashboardApprovalDataList) => ({
  type: DASHBOARD_FETCH_APPROVAL_DATA_SUCCESS,
  payload: data,
});

export const DashboardApprovalDataError = () => ({
  type: DASHBOARD_FETCH_APPROVAL_DATA_ERROR,
});
